<template>
  <div class="page">
    <div class="head-title">
      <div class="left">
        <ul class="breadcrumb">
          <li>
            <a href="#" class="active">{{ $t("Property") }}</a>
          </li>
          <li>-</li>
          <li>
            <router-link to="/property/allproperties" class="active">
              {{ $t("all") }} {{ $t("real estate") }} / {{ $t("units") }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <div class="head1">
          <h3>{{ $t("real estate") }} / {{ $t("units") }}</h3>
          <input
            type="text"
            :placeholder="$t('name') + ' ' + $t('realty')"
            v-model="realtyname"
            @keypress.enter="filter"
          />
          <input
            type="text"
            :placeholder="$t('name') + ' ' + $t('owner')"
            v-model="ownername"
            @keypress.enter="filter2"
          />
        </div>
        <div class="head2">
          <button>
            <router-link to="/property/createproperty" class="btn-download">
              <span class="text">
                <i class="bi bi-clipboard-plus-fill"></i>
                {{ $t("add") }} {{ $t("real estate") }} / {{ $t("units") }}
              </span>
            </router-link>
          </button>
        </div>
      </div>
      
      <div class="body">
        <table class="table">
          <thead>
            <tr>
              <th></th> <th>{{ $t("name") }} {{ $t("owner") }}</th>
              <th>{{ $t("real estate") }} {{ $t("count") }}</th>
              <th colspan="5"></th>
            </tr>
          </thead>
          
          <tbody v-for="owner in groupedProperties" :key="owner.name">
            <tr class="owner-row" @click="toggleOwner(owner.name)">
              <td>
                <i :class="expandedOwners.includes(owner.name) ? 'bi bi-chevron-down' : 'bi bi-chevron-right'"></i>
              </td>
              <td class="owner-name">
                <strong>{{ owner.name }}</strong>
              </td>
              <td>
                <span class="badge">{{ owner.properties.length }}</span>
              </td>
              <td colspan="5"></td>
            </tr>

            <tr v-if="expandedOwners.includes(owner.name)" class="table-sub-header">
              <th></th>
              <th>{{ $t("code") }}</th>
              <th>{{ $t("name") }} {{ $t("realty") }}</th>
              <th>{{ $t("type") }} {{ $t("realty") }}</th>
              <th>{{ $t("numbers") }} {{ $t("contracts") }}</th>
              <th>{{ $t("amount") }} {{ $t("contracts") }}</th>
              <th>{{ $t("units") }}</th>
            </tr>
            
            <tr 
              v-show="expandedOwners.includes(owner.name)" 
              v-for="x in owner.properties" 
              :key="x.pid"
              class="property-row"
            >
              <td></td>
              <td>
                <router-link :to="link + x.pid">{{ x.pid }}</router-link>
              </td>
              <td>
                <router-link :to="link + x.pid">{{ x.name }}</router-link>
              </td>
              <td>{{ $t(x.catitem) }}</td>
              <td>{{ x.count }}</td>
              <td>{{ Number(x.amount).toLocaleString() }}</td>
              <td>{{ x.prodata }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import { mapActions } from "vuex";

export default {
  props: ["css"],
  data() {
    return {
      cnum: store.state.cnum[0].cnum,
      property: [],
      property2: [],
      suppliers: 0,
      invoices: 0,
      bills: 0,
      salles: "",
      url: "",
      link: "/property/propertydetails/",
      realtyname: "",
      ownername: "",
      expandedOwners: [] // Tracks which owner summaries are open
    };
  },
  computed: {
    // Dynamically groups filtered properties by owner name
    groupedProperties() {
      const groups = {};
      this.property.forEach(item => {
        const name = item.ownername || 'Unknown Owner';
        if (!groups[name]) {
          groups[name] = [];
        }
        groups[name].push(item);
      });
      
      return Object.keys(groups).map(ownerName => ({
        name: ownerName,
        properties: groups[ownerName]
      }));
    }
  },
  async mounted() {
    const result = await axios.get("/data/getallpropertydetails");
    if (result.status == 200) {
      this.property = result.data.data;
      this.property2 = result.data.data;
    }
  },
  methods: {
    filter() {
      this.property = this.property2.filter((x) =>
        x.name.toLowerCase().includes(this.realtyname.toLowerCase())
      );
    },
    filter2() {
      this.property = this.property2.filter((x) =>
        x.ownername.toLowerCase().includes(this.ownername.toLowerCase())
      );
    },
    toggleOwner(ownerName) {
      const index = this.expandedOwners.indexOf(ownerName);
      if (index > -1) {
        this.expandedOwners.splice(index, 1); // Close accordion
      } else {
        this.expandedOwners.push(ownerName); // Open accordion
      }
    },
    ...mapActions(["redirectTo"]),
  },
};
</script>

<style lang="scss" scoped>
.page {
  direction: v-bind("css.EN");
  padding: 0.5%;
}

.main {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 1%;
}

.body {
  padding: 1%;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.owner-row {
  background-color: #f9f9f9;
  cursor: pointer;
  border-bottom: 2px solid #ddd;
  transition: background 0.2s ease;
  
  &:hover {
    background-color: #f1f1f1;
  }
}

.owner-name {
  color: rgba(98, 153, 174, 255);
  font-size: 1.1rem;
}

.table-sub-header {
  background-color: #eaeaea;
  font-size: 0.9rem;
}

.property-row {
  border-bottom: 1px solid #eee;
  background-color: #fff;
}

.badge {
  background-color: rgba(98, 153, 174, 255);
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.85rem;
}

ul {
  text-decoration: none;
  list-style-type: none;
  color: black;
}

.bi {
  margin: 1%;
}

.head {
  padding: 0.25%;
  display: flex;
  border-bottom-style: ridge;
}

.head1 {
  width: 60%;
}

.head1 input {
  margin: 0.5%;
  padding: 0.5%;
  border: none;
  border-radius: 5px;
  background-color: #eee;
}

.head2 {
  width: 40%;
  text-align: center;
}

.head2 button {
  margin: 0.5%;
  padding: 1%;
  border: none;
  border-radius: 5px;
  background-color: rgba(98, 153, 174, 255);
  color: white;
  font-size: small;
  width: 30%;
}

.head2 button a {
  color: white;
}
</style>